import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authApi, apiErr } from "./api";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!authApi.token()) { setChecking(false); return; }
    authApi.me().then(setUser).catch(() => authApi.clear()).finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    authApi.setToken(res.token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    authApi.clear();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, checking, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAdminAuth() { return useContext(AuthCtx); }

export function RequireAdmin({ children }) {
  const { user, checking } = useAdminAuth();
  const loc = useLocation();
  if (checking) return <div className="min-h-screen grid place-items-center bg-[#050505] text-zinc-400 font-mono text-xs uppercase tracking-[0.25em]">Yükleniyor…</div>;
  if (!user) return <Navigate to="/dekosta-yonetim/login" state={{ from: loc }} replace />;
  return children;
}

export { apiErr };
